// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"368":"6112357a","433":"fccafe8f","435":"a4386a8e","606":"ae393c70"}[chunkId] + ".chunk.js";
};